/* eslint-disable no-nested-ternary */
/** @type {import("@mui/material").SxProps<Theme>} */
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const styles = (
  theme,
  isPrequaled,
  isECC,
  holdPrequal,
  afterPrequalDesktopBackgroundImage,
  beforePrequaldesktopBackgroundImage,
  beforePrequelMobileBkgImg,
  infoBannerDesktopBackground,
  infoBannerMobileBackground,
  infoBannerTabletBackground
) => ({
  afterPrequalBannerText: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginLeft: '10px',
    },
  },
  BroadbandContainer: {
    justifyContent: 'center',
    marginTop: '0px',
    backgroundColor: theme.palette.secondary.contrastText,
    '& .MuiGrid-item': {
      paddingTop: '0px',
    },
  },
  advertImage: {
    height: '25rem',
    // width: '24.5rem',
    [theme.breakpoints.down('sm')]: {
      height: '20rem',
      // width: '11.5rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: '16rem',
      // width: '16rem',
    },
  },
  PrequalContainer: {
    pt: '0 !important',
    // marginTop: '1rem',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      background:
        isPrequaled || isECC
          ? holdPrequal
            ? theme.palette.primary.SkeletonBackground
            : `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${afterPrequalDesktopBackgroundImage}) center top/100% 100% no-repeat`
          : holdPrequal
          ? theme.palette.primary.SkeletonBackground
          : `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${beforePrequelMobileBkgImg}) center top/100% 100% no-repeat`,
    },
    [theme.breakpoints.up('md')]: {
      background:
        isPrequaled || isECC
          ? holdPrequal
            ? theme.palette.primary.SkeletonBackground
            : `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${afterPrequalDesktopBackgroundImage}) center top/100% 100% no-repeat`
          : holdPrequal
          ? theme.palette.primary.SkeletonBackground
          : `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${beforePrequaldesktopBackgroundImage}) center top/100% 100% no-repeat`,
      pl: '0 !important',
    },
  },
  ctaContainer: {
    pt: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    pl: '2.75rem !important',
    pr: '1.75rem',
    background: theme.palette.secondary.contrastText,
  },
  ctaHandler: {
    width: '11.125rem',
    padding: '0.5rem',

    position: 'unset',

    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    // boxShadow: `0px 4px 45px -9px ${theme.palette.primary.boxShadow1Darkest}`,
    cursor: 'pointer',

    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 4px 45px -9px ${theme.palette.primary.boxShadow}`,
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  mobileoffers: {
    [theme.breakpoints.down('md')]: {
      // display: 'flex',
      // justifyContent: 'center',
      // alignItems: 'center',
      width: '100%',
    },
  },
  prequalBannerContainer: {
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    display: 'flex',
    minHeight: '23.75rem',
    flexDirection: 'row',

    [theme.breakpoints.down('sm')]: {
      minHeight: isPrequaled ? '18.44rem' : '40.5rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      minHeight: isPrequaled ? '35rem' : '37.5rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    [theme.breakpoints.up('md')]: {
      // justifyContent: 'space-between',
      marginTop: '0rem',
    },
  },
  afterPrequalBanner: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    minHeight: '14rem',
    flexDirection: 'row',

    [theme.breakpoints.down('sm')]: {
      minHeight: !isPrequaled ? '16rem' : '22.75rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },

    [theme.breakpoints.between('sm', 'md')]: {
      minHeight: '15rem',
      justifyContent: 'flex-end',
      display: 'flex',
      flexDirection: 'column-reverse',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'center',
      marginTop: '0rem',
    },
  },
  prequalBox: {
    paddingTop: isPrequaled ? 0 : '2.8rem',
    [theme.breakpoints.down('sm')]: {
      pt: isPrequaled ? '2rem' : '0',
      // pl: isPrequaled ? '0' : '24px',
      width: '100%',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      paddingTop: 0,
      // pl: isPrequaled ? '0' : '24px',
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '580px',
    },
  },
  afterprequalBox: {
    paddingTop: 0,
  },

  PrequalBannerCurve: {
    position: 'absolute',
    width: { xs: 'calc(min(100%,100vw))', sm: 'calc(min(100%,100vw))', md: '100%', lg: '100%' },
    height: { xs: '2.75rem', sm: '2.875rem', lg: '4rem' },
    bottom: -1,
  },
  SecondaryPrequalBannerCurve: {
    width: '100%',
    height: { xs: '2.75rem', sm: '2.875rem', lg: '4rem' },
  },
  prequalAddress: {
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      pt: 4,
    },
  },
  prequalTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    pl: 1,
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      textAlign: 'center',
      marginTop: isPrequaled ? '2rem' : '1.7rem',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '0',
    },
  },
  beforePrequalBannerText: {
    [theme.breakpoints.up('md')]: {
      marginTop: '5rem',
    },
  },
  prequalInputContainer: {
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '1rem',
      marginBottom: '-2rem',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      alignItems: 'unset',
      marginTop: '2rem',
      pl: 1,
    },
  },
  prequalResultContainer: {
    [theme.breakpoints.up('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: '-3rem',
    },
    [theme.breakpoints.up('md')]: {
      flexDirection: 'column',
      alignItems: 'unset',
      marginTop: '1rem',
      pl: 1,
    },
  },
  prequalInputContainerBox: {
    flexDirection: 'column',
  },
  CodeandPhoneContainer: {
    flexDirection: 'row',
    [theme.breakpoints.up('xs')]: {
      justifyContent: 'space-around',
      gap: '5%',
    },
    [theme.breakpoints.only('sm')]: {
      justifyContent: 'center',
      gap: '5%',
    },
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      gap: '5%',
    },
  },
  errorText: {
    [theme.breakpoints.up('xs')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.up('md')]: {
      textAlign: 'unset',
    },
  },
  findEircode: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  PrequalAreaCode: {
    fontFamily: theme.typography.body1.fontFamily,
    borderRadius: '0.25rem',
    backgroundColor: theme.palette.primary.contrastText,
    textAlign: 'left',
    padding: '10px',
    fontStyle: 'normal',
    // fontWeight: 400,
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(94 / 360 * 100vw)',
      height: '2.5rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '5.875rem',
      height: '2.5rem',
    },

    '& .MuiSelect-select': {
      background: theme.palette.primary.contrastText,
      // paddingRight: '0px'
    },
    '&.Mui-error': {
      border: `1px solid ${theme.palette.secondary.asterisk}`,
      color: theme.palette.secondary.asterisk,
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.secondary.errorCTA,
      right: '0.4rem',
    },
    '& .MuiOutlinedInput-input': {
      padding: '8px 0 5px',
    },
  },
  AreaCodeNullColor: {
    color: theme.palette.primary.nullColor,
  },
  AreaCodeFilledColor: {
    color: theme.palette.primary.headerText,
  },
  PrequalPhoneNumber: {
    fontFamily: theme.typography.body1.fontFamily,
    background: theme.palette.primary.contrastText,
    borderRadius: '0.25rem',
    margin: '0rem',
    fontStyle: 'normal',
    width: '100%',
    height: '2.5rem',
    '& .MuiOutlinedInput-root': {
      padding: '0rem !important',
      height: '2.5rem',
      fontWeight: theme.typography.body1.fontWeight,
      fontSize: theme.typography.body1.fontSize,
      lineHeight: theme.typography.body1.lineHeight,
      [theme.breakpoints.down('md')]: {
        height: '2.875rem',
      },
      [theme.breakpoints.between('sm', 'md')]: {
        height: '2.875rem',
      },
    },
    '& .MuiInputBase-root': {
      '& .MuiInputBase-input': {
        [theme.breakpoints.down('sm')]: {
          padding: '0px 14px',
        },
      },
    },
    '& .MuiOutlinedInput-root.Mui-error ': {
      color: `${theme.palette.secondary.asterisk} !important`,
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
      borderWidth: '0rem',
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.asterisk,
      borderWidth: '1px !important',
      top: '-0.3rem',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: 'inherit',
    },
    '& .MuiOutlinedInput-root.Mui-hover .MuiOutlinedInput-notchedOutline': {
      border: '0',
    },
    '& #prequal-phone-number::placeholder': {
      color: theme.palette.primary.headerText,
      fontFamily: theme.typography.body1.fontFamily,
    },
  },
  useEircode: {
    // fontFamily: 'gt-walsheim-regular',
    // fontSize: '0.75rem',
    // fontStyle: 'normal',
    // fontWeight: 400,
    // lineHeight: '1.25rem',
    letterSpacing: '0.025rem',
    color: theme.palette.primary.contrastText,
  },
  PrequalPhoneNumberSubmitButton: {
    backgroundColor: theme.palette.primary.buttonColor,
    color: theme.palette.primary.contrastText,
    fontFamily: theme.typography.h1.fontFamily,
    fontStyle: 'normal',
    // fontWeight: 'bold',
    borderRadius: '2rem',
    minWidth: '11.5rem',
    maxHeight: '2.5rem',
    textTransform: 'none',
    outline: 'none',
    '&:hover': {
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      width: '10.5rem',
    },
    [theme.breakpoints.up('lg')]: {
      width: '11.5rem',
    },
    '&:disabled': {
      color: theme.palette.secondary.radioText,
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.header,
    },
    '&:focus': {
      outline: 'none',
    },
  },
  PhoneNumberTextFieldIconImage: {
    cursor: 'pointer',
    marginRight: '0.8rem',
    color: theme.palette.primary.offerMain,
  },
  PhoneValidity: {
    // fontStyle: 'normal',
    // fontWeight: 400,
    // fontSize: '0.875rem',
    letterSpacing: '0.025rem',
    color: theme.palette.primary.contrastText,
    position: 'relative',
    // fontFamily: 'gt-walsheim-regular',
    // lineHeight: '1.25rem',
    marginTop: '0.125rem',
  },
  PhoneNumberTextFieldTooltip: {
    padding: '4px 8px',
    width: 'fit-content',
  },
  toolTipText: {
    fontFamily: theme.typography.inputLabel.fontFamily,
    fontWeight: theme.typography.inputLabel.fontWeight,
    fontSize: theme.typography.inputLabel.fontSize,
    lineHeight: theme.typography.inputLabel.lineHeight,
  },
  checkAvailabilityButtonContainer: {
    textAlign: 'right',
    [theme.breakpoints.up('xs')]: {
      marginTop: '1rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
    [theme.breakpoints.up('md')]: {
      marginTop: '0rem',
    },
  },
  maintenanceContainer: {
    mt: 5,
    pl: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      mt: 3,
      alignItems: 'center',
    },
  },
  maintenanceMessage: {
    mb: 2,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
    },
  },
  callButton: {
    filter: `drop-shadow(0px 5px 10px ${theme.palette.primary.boxShadow1Darkest})`,
  },
  checkAvailabilityButton: {
    backgroundColor: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,

    height: '2.5rem',
    textTransform: 'none',
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    '&:hover': {
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    },
    [theme.breakpoints.up('xs')]: {
      width: '80vw',
    },
    [theme.breakpoints.up('sm')]: {
      width: '50vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '11.5rem',
    },
    '&:disabled': {
      color: theme.palette.primary.contrastText,
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.buttonInactiveColor,
    },
    '&:focus': {
      outline: 'revert',
    },
  },
  EircodeAutocompleteField: {
    background: theme.palette.primary.contrastText,
    borderRadius: '0.2rem',
    [theme.breakpoints.up('xs')]: {
      width: '90vw',
    },
    [theme.breakpoints.up('sm')]: {
      width: '70vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '18rem',
    },
    [theme.breakpoints.up('lg')]: {
      width: '23rem',
    },
    '& .MuiOutlinedInput-root': {
      padding: '1px',
      '& .MuiAutocomplete-input': {
        textTransform: 'uppercase',
        '&::placeholder': {
          textTransform: 'capitalize',
        },
      },
    },
  },
  EircodeInputField: {
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.buttonColor,
      },
    },
    [theme.breakpoints.up('xs')]: {
      height: '2.5rem',
    },
    [theme.breakpoints.up('md')]: {
      height: '2.5rem',
    },
  },
  AutocompleteListItems: {
    '& .MuiAutocomplete-listbox': {
      '& :hover': {
        color: theme.palette.primary.headerText,
        backgroundColor: theme.palette.primary.contrastText,
      },
      '& :not(active)': {
        backgroundColor: theme.palette.primary.contrastText,
      },
      '& li': {
        textTransform: 'capitalize',
        fontSize: theme.typography.body1.fontSize,
      },
    },
  },
  tacticalOfferBlock: {
    background: theme.palette.secondary.contrastText,
  },
  blankDiv: {
    height: '1.75rem',
    width: '100%',
    // background: theme.palette.primary.contrastText,
  },
  title: {
    color: theme.palette.primary.textColor3,
  },
  tvInfo: {
    pb: '3rem',
    [theme.breakpoints.down('sm')]: {
      pb: 4,
    },
  },
  tvAltInfo: {
    p: 0,
    [theme.breakpoints.down('sm')]: {
      pb: 0,
    },
  },
  carouselTitle: {
    color: theme.palette.primary.main,
  },
  contentCarousel: {
    display: 'flex',
    flexDirection: 'row',
  },

  prevArrow: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.errorCTA,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.disableCTA,
    },
  },
  nextArrow: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.errorCTA,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.disableCTA,
    },
  },
  offerCards: {
    [theme.breakpoints.between('sm', 'md')]: {
      width: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: '88%',
    },
    width: { sm: '90vw', md: '100%', lg: '100%' },
    display: { md: 'flex' },
    justifyContent: { md: 'center' },
    alignItems: { md: 'center' },
    flexDirection: { md: 'row' },
  },
  offerCardsText: {
    display: 'flex',
    flexDirection: 'row',
    mt: 2,
  },
  offerCardsTextLink: {
    textDecoration: 'underline',
    color: theme.palette.secondary.errorCTA,
  },
  offerSlider: {
    centerSwiper: {
      '& .swiper-wrapper': {
        [theme.breakpoints.up('md')]: {
          display: 'flex',
          justifyContent: 'center',
          gap: '1.5%',
        },
      },
    },
    swiper: {
      [theme.breakpoints.up('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.up('lg')]: {
        width: '73rem',
        '& .swiper-slide': {
          paddingRight: '0',
        },
      },

      [theme.breakpoints.between('sm', 'md')]: {
        '& .swiper-pagination': {
          position: 'inherit',
        },
      },
      [theme.breakpoints.up('md')]: {
        '& .swiper-pagination': {
          position: 'inherit',
        },
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel-broadband-tv-offer-card': {
        [theme.breakpoints.down('sm')]: {
          pb: '0.688rem !important',
        },
      },
      '& .content-carousel-broadband': {
        height: { xs: 'fit-content' },
        [theme.breakpoints.up('lg')]: {
          pl: 0,
          pr: 0,
        },
        [theme.breakpoints.down('sm')]: {
          pt: 0,
          pl: 2.25,
          pb: 9,
          pr: 2.25,
        },
        [theme.breakpoints.up('sm')]: {
          pt: 0,
          pl: 3.75,
          pb: 0,
          pr: 3.75,
        },
        [theme.breakpoints.between('sm', 'md')]: {
          p: 0,
        },
        [theme.breakpoints.only('md')]: {
          pt: 2,
          pl: 1.375,
          pb: 4,
          pr: 1.375,
        },
      },
      '& .content-carousel-broadband .swiper-slide': {
        paddingTop: '0rem',
        paddingBottom: '1rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme.breakpoints.up('lg')]: {
          '& .MuiCardContent-root': {
            p: 0,
          },
          '& .offerBody': {
            p: '2em',
          },
          '& .offer-card-body': {
            p: 0,
            width: '22.5rem',
          },
        },
        [theme.breakpoints.up('lg')]: {
          '& .offer-card': {
            width: '22.5rem',
            boxSizing: 'border-box',
          },
        },
        [theme.breakpoints.between('sm', 'md')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme.breakpoints.up('sm')]: {
          '& .offer-card': {
            width: '90%',
          },
        },
        [theme.breakpoints.down('sm')]: {
          '&.swiper-slide-active': {
            // transform: 'scale(1.1)',
            width: '100% !important',
            '& .offer-card': {
              width: 'inherit',
            },
          },
          '&.swiper-slide-prev': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
          '&.swiper-slide-next': {
            transform: 'scale3d(0.95,0.95,0.80)',
          },
        },
      },
    },
  },
  imageSlider: {
    swiper: {
      '& .content-carousel': {
        height: { xs: 'fit-content', md: 500 },
        pt: 2,
        pl: 2.5,
        pr: 2.5,
        pb: 8,
        [theme.breakpoints.down('sm')]: {
          pl: '1rem !important',
        },
      },
      '& .content-carousel .swiper-slide': {
        width: '100%',
        mr: 1,
        maxHeight: { xs: 'fit-content', md: 500 },
        [theme.breakpoints.down('sm')]: {
          ml: '-4px !important',
          mr: '10px !important',
        },
      },
      '& .content-carousel .swiper-wrapper': {
        [theme.breakpoints.down('sm')]: {
          maxWidth: '380px',
        },
      },
      '& .content-carousel .swiper-wrapper .MuiPaper-root': {
        [theme.breakpoints.down('sm')]: {
          minHeight: '356px',
        },
      },
      '& .swiper-pagination-bullet-active': {
        backgroundColor: theme.palette.primary.buttonColor,
      },
      '& .content-carousel .swiper-slide img': {
        height: { xs: 142 },
        m: '0 auto',
        display: 'block',
      },
      '& .content-carousel .swiper-button-next, .content-carousel .swiper-button-prev': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: 30,
        borderRadius: 30,
        '&:after': {
          fontSize: 16,
          color: theme?.palette?.secondary.dark,
          fontWeight: 700,
        },
      },
    },
    swiperIndex: {
      '& .image-selector': {
        maxHeight: 500,
      },
      '& .image-selector .swiper-slide': {
        // background: 'yellow',
        width: '100%',
        height: 'fit-content !important',
      },
      '& .image-selector .swiper-slide img': {
        // background: 'yellow',
        width: '100%',
        height: 'auto',
      },
      '& .image-selector .swiper-button-next': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: '100%',
        top: 'unset',
        bottom: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&:after': {
          fontSize: 16,
          fontWeight: 700,
          color: theme?.palette?.secondary.dark,
          transform: 'rotate(90deg)',
        },
      },
      '& .image-selector .swiper-button-prev': {
        bgcolor: theme.palette.primary.contrastText,
        height: 30,
        width: '100%',
        m: 0,
        top: 0,
        left: 0,
        right: 0,
        opacity: 0.5,
        '&.swiper-button-disabled': {
          display: 'none',
        },
        '&:after': {
          fontSize: 16,
          fontWeight: 700,
          color: theme?.palette?.secondary.dark,
          transform: 'rotate(90deg)',
        },
      },
    },
  },
  submitCTAContainerBroadband: {
    display: 'flex',
    justifyContent: 'center',
    m: '2.5rem 0 3.75rem 0',
    [theme.breakpoints.down('md')]: {
      m: '2rem 2rem 3.75rem 2rem',
    },
    [theme.breakpoints.down('sm')]: {
      m: '2rem 2rem 3.75rem 2rem',
    },
  },
  submitCTAbroadband: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    border: `0.063rem solid ${theme.palette.primary.textColor2}`,
    cursor: 'pointer',
    textTransform: 'capitalize',
    width: '6.625rem',
    height: '40px',
    background: theme.palette.primary.buttonColor,
    color: theme.palette.secondary.contrastText,
    boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow1Dark},0px 10px 14px 1px  ${theme.palette.primary.boxShadow2Medium},0px 4px 18px 3px  ${theme.palette.primary.boxShadow2Lite}`,
    '&:hover': {
      border: `0.063rem solid ${theme.palette.primary.textColor2}`,
      background: theme.palette.primary.buttonPrimaryHoverColor,
      color: theme.palette.primary.contrastText,
      boxShadow: `0px 6px 6px -3px ${theme.palette.primary.boxShadow}, 0px 10px 14px 1px ${theme.palette.primary.boxShadow}, 0px 4px 18px 3px ${theme.palette.primary.boxShadow}`,
    },
  },
  InfoBannerMainContainer: {
    marginTop: '5rem',
    // marginBottom: '2rem',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1rem',
      marginBottom: '1rem',
      background: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${infoBannerMobileBackground}) top left/cover no-repeat ${theme.palette.primary.infoBannerBackround}`,
      minHeight: '26.505rem',
    },
    [theme.breakpoints.up('sm')]: {
      background: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${infoBannerTabletBackground}) right/contain no-repeat ${theme.palette.primary.infoBannerBackround}`,
      height: 'auto',
      maxWidth: '100%',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      background: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${infoBannerTabletBackground}) right/cover no-repeat ${theme.palette.primary.infoBannerBackround}`,
      minHeight: '370px',
    },
    [theme.breakpoints.up('lg')]: {
      background: `url(${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${infoBannerDesktopBackground}) center right/cover no-repeat ${theme.palette.primary.infoBannerBackround}`,
      minHeight: '370px',
    },
  },
  infoBannerContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center',
      margin: '11.93rem 0 0 0',
      maxWidth: '100%',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      maxHeight: '370px',
      margin: '4.81rem 9.07px 4.81rem 8.53px',
    },
    [theme.breakpoints.up('sm')]: {
      maxHeight: '370px',
      margin: '4.81rem 0px',
    },
  },
  infoBannerTitleContainer: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'center',
      textAlign: 'center',
    },
    [theme.breakpoints.up('sm')]: {
      alignItems: 'unset',
      textAlign: 'unset',
      marginTop: '0rem',
      marginBottom: '0rem',
      width: '74%',
    },
  },
  infoBannerTitle: {
    [theme.breakpoints.down('sm')]: {
      width: '18.438rem',
      height: '3.866rem',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      height: 'unset',
    },
    [theme.breakpoints.up('md')]: {
      width: '26.625rem',

      height: 'unset',
    },
  },
  infoBannerDescription: {
    marginTop: '1rem',
    lineHeight: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      height: '1.5rem',
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      width: '24.25rem',
    },
  },
  infoSubmitCTA: {
    [theme.breakpoints.down('sm')]: {
      width: '16.375rem',
      marginTop: '1.5rem',
    },
    marginTop: '2.5rem',
    border: `0.063rem solid ${theme.palette.primary.textColor2} !important`,

    width: 'fit-content',
    height: '40px',
    // background: theme.palette.secondary.contrastText,
    color: theme.palette.primary.contrastText,
    boxShadow: `0px 4px 51px -6px ${theme.palette.primary.boxShadow3Lite}`,
    '&:hover': {
      background: theme?.palette?.primary?.buttonPrimaryHoverColor,
      color: theme?.palette?.secondary?.contrastText,
      border: `0.063rem solid ${theme.palette.primary.textColor2} !important`,
      boxShadow: `0px 4px 51px -6px ${theme.palette.primary.boxShadow3Lite}`,
    },
  },
  infoBannerButtonText: {
    height: '24px',
    color: theme?.palette?.secondary?.contrastText,
    '&:hover': {
      color: theme?.palette?.secondary?.contrastText,
    },
  },
  faqContainerSuperMain: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '1rem',
    paddingBottom: '6rem',
  },
});

export default styles;
